import { render, staticRenderFns } from "./JStatus.vue?vue&type=template&id=b5068cd6&scoped=true&"
import script from "./JStatus.vue?vue&type=script&lang=js&"
export * from "./JStatus.vue?vue&type=script&lang=js&"
import style0 from "./JStatus.vue?vue&type=style&index=0&id=b5068cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5068cd6",
  null
  
)

export default component.exports